import { __decorate } from "tslib";
import { mixins } from 'vue-class-component';
import { Component } from 'vue-property-decorator';
import BaseCardSectionHeader from '@/components/dashboard_card/BaseCardSectionHeader.vue';
import SoldProductsQuery from '@/plugins/graphql/queries/v2/ecommerce/today-total-sales-amount-full-details.gql';
import RouteParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import PerformanceListCountMixin from '@/helpers/vue_mixins/PerformanceListCountMixin';
import SalesAmountList from '@/components/v2/ecommerce/SalesAmountList.vue';
import Avatar from '@/components/avatar/Index.vue';
import PageTitle from '@/components/v2/PageTitle.vue';
let SalesAmountIndex = class SalesAmountIndex extends mixins(RouteParamsAppMixin, PerformanceListCountMixin) {
};
SalesAmountIndex = __decorate([
    Component({
        components: {
            BaseCardSectionHeader,
            SalesAmountList,
            Avatar,
            PageTitle,
        },
        apollo: {
            latestSoldProducts: {
                query: SoldProductsQuery,
                variables() {
                    return {
                        appUuid: this.appUUID,
                        withinDay: true,
                    };
                },
            },
        },
    })
], SalesAmountIndex);
export default SalesAmountIndex;
